import { FC, useState } from "react";
import AllOptimiseRouteComponent from "./AllOptimiseRouteComponent";
import DetailOptimiseRouteComponent from "./DetailOptimiseRouteComponent";
import { useDispatch } from "react-redux";
import { changeSelectedRoute } from "../../../redux/navmode.action";

interface OptimiseRouteSectionProps {
  mode: "create" | "update";
  progressMap: number;
}

const OptimiseRouteSection: FC<OptimiseRouteSectionProps> = ({
  mode,
  progressMap,
}) => {
  const [isOpenDetailRoute, setIsOpenDetailRoute] = useState(false);

  const dispatch = useDispatch();

  return (
    <>
      {isOpenDetailRoute ? (
        <DetailOptimiseRouteComponent
          setIsOpenDetailRoute={(isOpen: boolean) => {
            setIsOpenDetailRoute(isOpen);

            if (!isOpen) {
              dispatch(changeSelectedRoute(null));
            }
          }}
          mode={mode}
        />
      ) : (
        <AllOptimiseRouteComponent
          setIsOpenDetailRoute={setIsOpenDetailRoute}
          mode={mode}
          progressMap={progressMap}
        />
      )}
    </>
  );
};

export default OptimiseRouteSection;
